import { Component, ViewEncapsulation, OnInit, ViewContainerRef, ViewChild, ElementRef, ComponentRef } from '@angular/core';
import { Menu } from '@grapecity/wijmo.input';
import { CellRange, CellType, FlexGrid , AllowDragging} from '@grapecity/wijmo.grid';
import { EventArgs } from '@grapecity/wijmo';
import { FMenu } from 'src/app/commons/kymw02/function-menu/fmenu';
import { FlexGridFilter, FilterType } from '@grapecity/wijmo.grid.filter';
import { PlessViewUtils } from 'src/app/shared/utils/pless-view-utils.service';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { DataGridUtil } from '../../../commons/kymw00/data-grid-util';
import { PlessAlert } from '../../../shared/pless-alert/pless-alert.component';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW0B00Model } from '../../../commons/kymw0b/kymw0b00/kymw0b00.model';
import { KYMW0B00Component } from '../../../commons/kymw0b/kymw0b00/kymw0b00.component';
import { KYMW0B00OutputModel } from '../../../commons/kymw0b/kymw0b00/vo/kymw0b00-output.model';
import { KYMW0C00Component } from '../../../commons/kymw0c/kymw0c00/kymw0c00.component';
import { KYMW0C00InputModel } from '../../../commons/kymw0c/kymw0c00/vo/kymw0c00-input.model';
import { KYMW0E00Component } from '../../../commons/kymw0e/kymw0e00/kymw0e00.component';
import { KYMW0E00InputModel } from '../../../commons/kymw0e/kymw0e00/vo/kymw0e00-input.model';
import { KYMW0E00OutputModel } from '../../../commons/kymw0e/kymw0e00/vo/kymw0e00-output.model';

import { KYMW1700Model } from './kymw1700.model';
import { KYMW1704Component } from '../kymw1704/kymw1704.component';
import { KYMW1705Component } from '../kymw1705/kymw1705.component';
import { KYMW1706Component } from '../kymw1706/kymw1706.component';
import { KYMW1707Component } from '../kymw1707/kymw1707.component';

import { DeleteImageInfoService } from './api-services/delete-image-info.service';
import { FunctionMenuService } from 'src/app/commons/kymw02/function-menu/function-menu.service';
import { GetImageInfoService } from './api-services/get-image-info.service';
import { GetImageInfoRequestModel } from './vo/get-image-info-request.model';
import { GetOrderListService } from 'src/app/commons/kymw02/api-services/get-order-list.service';
import { GetOrderingOutputService } from './api-services/get-ordering-output.service';
import { GetPhotoContentsListOutputService } from './api-services/get-photo-contents-list-output.service';
import { GetReferenceImageOutputService } from './api-services/get-reference-image-output.service';
import { GetSampleOrderingOutputService } from './api-services/get-sample-ordering-output.service';
import { UpdateC2pfStatusService } from './api-services/update-c2pf-status.service';
import { UpdateImageInfoService } from './api-services/update-image-info.service';
import { UpdateImageKindService } from './api-services/update-image-kind.service';
import { UpdateImageKindModel } from './vo/update-image-kind.model';
import { GetImageInfoResponseModel } from './vo/get-image-info-response.model';
import { UpdateImageInfoRequestModel } from './vo/update-image-info-request.model';
import { ImageInfoModel } from './vo/image-info.model';
import { GetCodeListService } from 'src/app/commons/kymw02/api-services/get-code-list.service';
import { KYMW1708Component } from '../kymw1708/kymw1708.component';
import { KYMW1709Component } from '../kymw1709/kymw1709.component';
import { CodeComboBoxComponent } from '../../../commons/kymw02/combo-box/code-combo-box/code-combo-box.component';
import { FileDownloadConfirmService } from 'src/app/commons/kymw02/file-download-confirm/file-download-confirm.service';

/**
 * 画像作成管理画面を管理するクラス
 *
 * @export KYMW1700Component
 * @class KYMW1700Component
 */
@Component({
  selector: 'app-kymw1700',
  templateUrl: 'kymw1700.component.html',
  styleUrls: ['kymw1700.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW1700Component extends PlessViewHelperSub implements OnInit {

  @ViewChild('btn_Search', { static: true }) btn_Search: ElementRef;
  @ViewChild('btn_ImageKindSync', { static: true }) btn_ImageKindSync: ElementRef;
  @ViewChild('btn_RegisterMultCode', { static: true }) btn_RegisterMultCode: ElementRef;
  @ViewChild('btn_Remind', { static: true }) btn_Remind: ElementRef;
  @ViewChild('btn_RegisterPastImage', { static: true }) btn_RegisterPastImage: ElementRef;
  @ViewChild('btn_Approval', { static: true }) btn_Approval: ElementRef;
  @ViewChild('btn_Remand', { static: true }) btn_Remand: ElementRef;
  @ViewChild('btn_Save', { static: true }) btn_Save: ElementRef;
  @ViewChild('cmb_OutputFileSelection', { static: true }) cmb_OutputFileSelection: CodeComboBoxComponent;
  @ViewChild('btn_OutputFile', { static: true }) btn_OutputFile: ElementRef;
  @ViewChild('chk_AllChecked', { static: false }) chk_AllChecked: ElementRef;
  @ViewChild('dtg_ImageInfo', { static: true }) dtg_ImageInfo: FlexGrid;
  @ViewChild('fltr_Main', { static: false }) fltr_Main: FlexGridFilter;

  public kymw1700Model: KYMW1700Model = new KYMW1700Model();

  // 画像検索画面への検索条件受渡用モデル
  public kymw0B00ModelParent: KYMW0B00Model = new KYMW0B00Model();

  // コンテキストメニュー
  private contextMenu: Menu;

  public kymw0C00ComponentRef: ComponentRef<any> = null;
  public kymw0C00Component: KYMW0C00Component;

  // フィルター対象カラム
  private static readonly FILTER_TARGET_COLUMS = [
    'startOrderCode',
    'startDelivCatalogId',
    'statusName',
    'className',
    'pcode',
    'guideGoodsName',
    'guideStandardName',
    'imageFileName',
    'c2pfTarget',
    'imageKindName',
    'imageUseMethodName',
    'photographingNo',
    'delivCatalogMonth',
    'delivCatalogTime',
    'packaging',
    'plating',
    'cookNecessary',
    'cookUnnecessary',
    'explain',
    'other',
    'backSide',
    'tempRangeName',
    'multipleCode',
    'pastImageInfo',
    'imageCaution',
    'photoContentsName',
    'referenceImageNum',
    'billingName',
    'c2pfStatusName',
    'delayFlag',
    'supplierInfo',
    'supplierAnnouncement',
    'statusRemandReason',
    'imageInfoChange',
    'remarks',
    'photoSchedule',
    'photographingChangeSchedul',
    'carriedForward',
    'imageInstructDate',
    'imageInstructUser',
    'buyerName',
    'c2pfUpdateDate',
    'peaceUpdateDate',
    'printDate',
    'photoStudio',
    'janCode',
    'imageGroupNo',
    'smallClass',
    'buyerCode',
    'billingCode',
    'sampleOrderingCode',
    'sampleOrderingName',
    'supplierSalesStaffName',
    'ebaseSpecCode'
  ];
  
  /**
   * Creates an instance of KYMW1700Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {ViewContainerRef} viewContainerRef
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW1700Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private getCodeListService: GetCodeListService,
    private deleteImageInfoService: DeleteImageInfoService,
    private fmenuService: FunctionMenuService,
    private getImageInfoService: GetImageInfoService,
    private getOrderListService: GetOrderListService,
    private getOrderingOutputService: GetOrderingOutputService,
    private getPhotoContentsListOutputService: GetPhotoContentsListOutputService,
    private getReferenceImageOutputService: GetReferenceImageOutputService,
    private getSampleOrderingOutputService: GetSampleOrderingOutputService,
    private updateC2pfStatusService: UpdateC2pfStatusService,
    private updateImageInfoService: UpdateImageInfoService,
    private updateImageKindService: UpdateImageKindService,
    public viewContainerRef: ViewContainerRef,
    private fileDownloadConfirmService: FileDownloadConfirmService,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof PhaseRegistComponent
   */
  // eslint-disable-next-line
  public ngOnInit(): void {
    //「帳票出力」「保存」ボタンを非活性にする。
    this.btn_OutputFile.nativeElement.disabled = true;
    this.btn_Save.nativeElement.disabled = true;

    // グリッドのセルクリックでチェックボックスにチェック
    this.dtg_ImageInfo.hostElement.addEventListener("mouseup", (e: MouseEvent) => {
      const ht = this.dtg_ImageInfo.hitTest(e);
      if (0 <= ht.row && ht.target.className !== 'wj-cell wj-header wj-align-center' && ht.col === 0) {
        document.getElementById(`cb_${ht.row}`).click();
      }
    });

    // 受注コードリスト取得処理（/KYMW02/getOrderList）を呼び出す。	
    this.getOrderListService.execute(this.kymw1700Model, 'orderCodeList', () => { });

    this.componentName = 'KYMW1700';

    // 権限取得
    if (this.getFuncPermission('KYMW1700') === '1') {
      this.kymw1700Model.btnImageMakeInstructionDisabled = true;
      this.kymw1700Model.btnImageAllRegistDisabled = true;
      this.kymw1700Model.btnImageSingleRegistDisabled = true;
      this.kymw1700Model.btnOrderSheetOutDisabled = true;
    }

    // コンテキストメニュー設定
    this.setContextMenu();

    this.btn_Search.nativeElement.focus();

    this.dtg_ImageInfo.itemsSourceChanged.addHandler((sender: FlexGrid, event: EventArgs) => {
      this.dtg_ImageInfo.selection = new CellRange(-1, -1, -1, -1);
    });

    // FlexGridのセル描画タイミングで呼び出される処理
    this.dtg_ImageInfo.formatItem.addHandler((sender: FlexGrid, event: EventArgs) => {
      // データグリッド行の背景色設定処理
      this.setColorPattern(this.dtg_ImageInfo);
    });

    // 画像種類リスト取得
    // app-code-combo-boxを使用すると常にAPIが動いてエラーが出てしまうことがあるため、
    // 先にAPIを実行しリストを取得する。
    this.getCodeListService.execute('ct366', '', this.kymw1700Model, 'imageKindList', null, null, null);

  }
  
  public initMain(g: FlexGrid) {
    // フィルタ 設定
    if (this.fltr_Main) {
      this.fltr_Main.defaultFilterType = FilterType.Both;
      this.fltr_Main.showSortButtons = false;
      this.fltr_Main.filterColumns = KYMW1700Component.FILTER_TARGET_COLUMS;
      // this.fltr_Main.filterChanged.addHandler(
      //   (f: FlexGridFilter, e: EventArgs) => {
      //     const activeFilter = f.filterColumns.find(
      //       _ => f.getColumnFilter(_).isActive
      //     );
      //     if (!activeFilter) {
      //       g.allowDragging = AllowDragging.Rows;
      //     } else {
      //       g.allowDragging = AllowDragging.None;
      //     }
      //   }
      // );
    }
  }
  
  /**
   * 全チェック処理
   * @param event 選択時イベント
   */
  public eventClickHandler_CheckToggleAll(): void {
    // チェックなし→チェックありの場合、全てチェックをつける
    if (this.chk_AllChecked.nativeElement.checked) {
      for (const imageInfo of this.kymw1700Model.imageInfoList) {
        imageInfo.checked = true;
      }
      return;
    }
    // チェックあり→チェックなしの場合、全てチェックをはずす
    for (const imageInfo of this.kymw1700Model.imageInfoList) {
      imageInfo.checked = false;
    }
  }

  /**
   * 「検索」ボタン押下イベント処理
   *
   * @memberof KYMW1700Component
   */
  public eventClickHandler_Search(): void {
    // ①既に検索条件情報が保持されている場合		
    //   ・InputVOに検索条件情報を格納し、『画像検索』画面に渡して呼び出す。	
    //   ※リクエストパラメータにC2PF検索項目表示フラグを"1"で設定する。	
    const componentRef = this.dialogService.openModal(KYMW0B00Component);
    const instance = componentRef.componentInstance as KYMW0B00Component;
    instance.parent = this;
    instance.kymw0B00Model = this.kymw0B00ModelParent;
    instance.setInterfaceParam(this.kymw1700Model.getKYMW0B00InputVO());
    instance.setKYMW0B00Parameter = (outputVO: KYMW0B00OutputModel) => {
      this.kymw1700Model.existsSearchCondition = true;
      this.kymw1700Model.kymw0B00Param = outputVO;
      this.getImageInfoList();
    };
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  /**
   * 出力帳票選択の値を変更
   */
  public eventChangeHandler_OutputFile() {
    // 空白に変更した場合帳票出力ボタンを非活性にする。
    this.btn_OutputFile.nativeElement.disabled = PlessViewUtils.isEmpty(this.cmb_OutputFileSelection.selectedCodeValue);
  }

  /**
   * 帳票出力ボタンを押下
   */
  public eventClickHandler_OutputFile() {
    // 【帳票出力】	
    // ・	サンプル発注書・撮影指示書、撮影指示書、撮影リスト、参考資料の出力が可能。
    // 一覧のチェックをつけた行を対象に出力を行う。

    /** 一覧のチェックをつけた行を対象リスト */
    const checkedList = this.kymw1700Model.imageInfoList.filter(_ => _.checked);
    /** 帳票出力コンボボックスの選択 */
    const outputFileDiv = this.cmb_OutputFileSelection.selectedIndex;

    if ((outputFileDiv == 1 || outputFileDiv == 2 || outputFileDiv == 4) && checkedList.length < 1) {   // 選択件数が空白
      this.dialogService.openAlertGetMessage('E0112', ['選択チェック行']);
      return;

    } else if (outputFileDiv == 3 && this.kymw1700Model.imageInfoList.length == 0) {    // 検索結果が0件
      this.dialogService.openAlertGetMessage('E0112', ['データ']);
      return;
    }

    /** ファイル名用 現在日時 */
    const nowDate = PlessViewUtilsSub.formatedNowDate('YYYYMMDD_hhmmss');
    if (outputFileDiv == 1) {
      // リクエストパラメーター用リスト
      const imageGroupNoList: Array<string> = checkedList.map(image => image.imageGroupNo);

      // サンプル発注書・撮影指示書PDF出力項目取得
      this.getSampleOrderingOutputService.execute(imageGroupNoList, (data) => {
        const fileName = 'サンプル発注書・撮影指示書_' + nowDate + '.zip';
        this.fileDownloadConfirmService.show(data, fileName);
      });
    } else if (outputFileDiv == 2) {
      // リクエストパラメーター用リスト
      const imageGroupNoList: Array<string> = checkedList.map(image => image.imageGroupNo);

      // 撮影指示書
      this.getOrderingOutputService.execute(imageGroupNoList, (data) => {
        const fileName = '撮影指示書_' + nowDate + '.zip';
        this.fileDownloadConfirmService.show(data, fileName);
      });
    } else if (outputFileDiv == 3) {
      // リクエストパラメーター用リスト
      const voList = this.kymw1700Model.createPhotoContentsList(this.kymw1700Model.imageInfoList);

      // 撮影リスト
      this.getPhotoContentsListOutputService.execute(voList, (data) => {
        const fileName = '撮影リスト_' + nowDate + '.xls';
        this.fileDownloadConfirmService.show(data, fileName);
      });
    } else if (outputFileDiv == 4) {
      // リクエストパラメーター用リスト
      const imageIdList: Array<string> = checkedList.map(image => image.imageId);

      // 参考資料
      this.getReferenceImageOutputService.execute(imageIdList, (data) => {
        const fileName = '参考資料_' + nowDate + '.zip';
        this.fileDownloadConfirmService.show(data, fileName);
      });
    }
  }

  /**
   * 表示モード切替
   * @param mode (0: 通常モード, 1: 編集モード)
   * @returns 
   */
  public eventChangeHandler_Mode(mode: number) {
    // 通常モードを選択した場合			
    if (mode === 0) {
      // 画像ファイル一覧の内容が変更されている場合、警告メッセージを表示する。
      const modified = this.kymw1700Model.imageInfoList.filter(_ => _.modified).length;
      if (modified > 0) {
        this.dialogService.openAlertGetMessage('Q0107', ['画像ファイル情報'], (closeEvent: number) => {
          if (closeEvent === PlessAlert.Yes) {
            // 編集をリセットする
            this.getImageInfoList();
            // 編集パターン：通常モード（画像ファイル一覧の入力項目を編集不可にする）に変更	
            this.kymw1700Model.displayType = '0';
            this.kymw1700Model.mode = mode;
            this.dtg_ImageInfo.refresh();
            this.setDisabled(mode);
          } else {
            this.kymw1700Model.displayType = '1';
            this.kymw1700Model.mode = 1;
          }
        });
        return;
      }
    } else if (mode === 1) {
      // 出力帳票選択コンボボックスを空に変更
      this.cmb_OutputFileSelection.selectedCodeValue = '';
      // 出力帳票選択を空にしたことに伴うボタンの活性制御
      this.eventChangeHandler_OutputFile();
    }
    this.setDisabled(mode);
  }

  /**
   * 表示モード変更による要素の活性制御
   */
  public setDisabled(mode) {
    // 出力帳票選択：一覧編集モードの場合は非活性化
    this.cmb_OutputFileSelection.disabled = mode === 1;
    // 1-2.ボタンの活性非活性処理を行う。	
    //     ・検索	
    this.btn_Search.nativeElement.disabled = mode === 1;
    //     ・画像種類同期	
    this.btn_ImageKindSync.nativeElement.disabled = mode === 1;
    //     ・複数コード登録	
    this.btn_RegisterMultCode.nativeElement.disabled = mode === 1;
    //     ・催促	
    this.btn_Remind.nativeElement.disabled = mode === 1;
    //     ・過去画像登録	
    this.btn_RegisterPastImage.nativeElement.disabled = mode === 1;
    //     ・承認	
    this.btn_Approval.nativeElement.disabled = mode === 1;
    //     ・差し戻し	
    this.btn_Remand.nativeElement.disabled = mode === 1;
    //     ・保存	
    this.btn_Save.nativeElement.disabled = mode === 0;
    // 編集パターン：一覧編集モード（画像ファイル一覧の入力項目を編集可にする）に変更
    this.kymw1700Model.mode = mode;
  }

  /**
   * 画像一覧の値を変更したときの処理
   * @param $event 
   */
  public eventChangeHandler_DtgImageInfoCell(index: number) {
    // チェックボックスにチェックを入れる
    const checkbox = document.getElementById(`cb_${index.toString()}`) as HTMLInputElement;
    checkbox.checked = true;
    // 変更済にする
    this.kymw1700Model.imageInfoList[index].modified = true;
    this.kymw1700Model.imageInfoList[index].checked = true;
  }

  /**
   * 保存ボタンを押下
   */
  public eventClickHandler_Save() {
    // ・選択チェック状態の行が１行もない場合、下記のメッセージを表示し処理を終了する。
    const isNotChecked = this.kymw1700Model.imageInfoList.filter(_ => _.checked).length === 0;
    if (isNotChecked) {
      this.dialogService.openAlertGetMessage('E0103', ['作成指示済み画像ファイル']);
      return;
    }
    // ・必須チェック、属性チェック、桁数チェックを行う。	
    // ※チェック内容はAPI仕様書を参照	
    const targetImageInfo: UpdateImageInfoRequestModel[] = this.kymw1700Model.imageInfoList.filter(_ => _.checked)
      .map(_ => {
        const obj = {
          imageKind: _.imageKind,
          photographingNo: _.photographingNo,
          supplierAnnouncement: _.supplierAnnouncement,
          imageInfoChange: _.imageInfoChange,
          remarks: _.remarks,
          photoSchedule: _.photoSchedule,
          photographingChangeSchedule: _.photographingChangeSchedule,
          carriedForward: _.carriedForward,
          imageID: _.imageId,
          dispPhotoSchedule: _.photoSchedule,
          c2pfTarget: _.c2pfTarget,
          imageFileName: _.imageFileName,
          classCode: _.classCode,
          className: _.className,
          startOrderCode: _.startOrderCode,
          photoContentsName: _.photoContentsName,
          tempRangeName: _.tempRangeName
        };
        return obj as UpdateImageInfoRequestModel;
      });
    // 入力必須チェック処理
    let checkEmpty = targetImageInfo.filter(_ => PlessViewUtilsSub.isEmpty(_.imageKind) || PlessViewUtilsSub.isEmpty(_.imageID));
    if (checkEmpty.length > 0) {
      this.dialogService.openAlertGetMessage('W0001', ['画像種類'], null);
      return;
    }
    // 属性チェック
    let checkNum = targetImageInfo.filter(_ => !PlessViewUtilsSub.isIntString(_.imageID));
    if (checkNum.length > 0) {
      this.dialogService.openAlertGetMessage('W0003', ['画像ID'], null);
      return;
    }
    // 桁数チェック
    const targetCheckLength = [
      {
        id: 'photographingNo',
        name: '画像種類',
        leng: 10
      },
      {
        id: 'supplierAnnouncement',
        name: '取引先への連絡事項',
        leng: 128
      },
      {
        id: 'imageInfoChange',
        name: '変更',
        leng: 128
      },
      {
        id: 'remarks',
        name: '備考',
        leng: 128
      },
      {
        id: 'carriedForward',
        name: '繰越',
        leng: 128
      },
      {
        id: 'imageID',
        name: '画像ＩＤ',
        leng: 9
      }
    ];
    for(const target of targetCheckLength ) {
      for ( const _ of targetImageInfo ) {
        if (_[target.id].length > target.leng) {
          this.dialogService.openAlertGetMessage('W0007', [target.name, PlessViewUtilsSub.numberToString(target.leng)], null);
          return;
        }
      }
    };
    //  選択したデータの入力内容を保存する。
    this.updateImageInfoService.execute(targetImageInfo, (data) => {
      if (data.updateImageInfo.filter(_ => _.ResultCode !== 0).length !== 0) {
        const errorMessage = data.updateImageInfo
          .filter(_ => _.ResultCode !== 0).map(_ => _.ErrorContent);
        this.dialogService.openAlert(PlessViewUtilsSub.arrayToString(errorMessage, '\n'), 'E', [PlessAlert.Yes_Error]);
        return
      }
      // 再検索
      this.getImageInfoList();
      // 更新が成功した場合
      this.dialogService.openAlertGetMessage('I0106', ['保存が完了']);
    });
  }

  /**
   * 画像種類同期ボタンを押下
   */
  public eventClickHandler_ImageKindSync() {
    // C2PF対象のデータを一覧から取得する
    const updateList: UpdateImageKindModel[] = this.kymw1700Model.imageInfoList.filter(_ => _.c2pfTarget === '1').map(_ => {
      return {
        imageId: _.imageId,
        imageUseMethod: _.imageUseMethod,
        imageKind: _.imageKind
      } as UpdateImageKindModel;
    });
    // C2PF対象のデータがない場合は終了する
    if (updateList.length === 0) {
      this.dialogService.openAlertGetMessage('E0111', ['作成指示済み画像ファイル']);
      return;
    }
    // 画像種類同期処理を行う。
    this.updateImageKindService.execute(updateList, () => {
      this.dialogService.openAlertGetMessage('I0106', ['画像種類同期が完了']);
      this.getImageInfoList();
    });
  }

  /**
   * 複数コード登録
   */
  public eventClickHandler_RegisterMultCode() {
    // ・選択チェック状態の行が１行もない場合、下記のメッセージを表示し処理を終了する。
    const isNotChecked = this.kymw1700Model.imageInfoList.filter(_ => _.checked).length === 0;
    if (isNotChecked) {
      this.dialogService.openAlertGetMessage('E0103', ['作成指示済み画像ファイル']);
      return;
    }
    // ・選択チェック状態の行が複数ある場合、メッセージを表示し処理を終了する。
    const isMultiChecked = this.kymw1700Model.imageInfoList.filter(_ => _.checked).length > 1;
    if (isMultiChecked) {
      this.dialogService.openAlertGetMessage('E0550', ['作成指示済み画像ファイル']);
      return;
    }
    // ・選択した行の複数コード登録が未設定の場合、メッセージを表示し処理を終了する。
    const multipleCodeNonRegistered = this.kymw1700Model.imageInfoList.filter(_ => _.checked && PlessViewUtilsSub.isEmpty(_.multipleCode)).length > 0;
    if (multipleCodeNonRegistered) {
      this.dialogService.openAlertGetMessage('E0557', null);
      return;
    }
    // ・選択した行の画像使用方法が「撮影」以外の場合、メッセージを表示し処理を終了する。
    const imageUseMethodRegistered = this.kymw1700Model.imageInfoList.filter(_ => _.checked && _.imageUseMethodName !== '撮影').length > 0;
    if (imageUseMethodRegistered) {
      this.dialogService.openAlertGetMessage('E0568', null);
      return;
    }
    // 複数コード登録ダイアログを開く
    const componentRef = this.dialogService.openModal(KYMW1708Component);
    const instance = componentRef.componentInstance as KYMW1708Component;
    const selectedImage = this.kymw1700Model.imageInfoList.filter(_ => _.checked).map(_ => _.imageId);
    instance.setParameter(selectedImage[0]);
    instance.closeFunction = (refreshDisplay) => {
      componentRef.close();
      if (refreshDisplay) {
        this.getImageInfoList();
      }
    };
  }

  /**
   * 催促ボタンを押下
   * @returns 
   */
  public eventClickHandler_Remind() {
    // ・選択チェック状態の行が１行もない場合、下記のメッセージを表示し処理を終了する。
    const isNotChecked = this.kymw1700Model.imageInfoList.filter(_ => _.checked).length === 0;
    if (isNotChecked) {
      this.dialogService.openAlertGetMessage('E0103', ['作成指示済み画像ファイル']);
      return;
    }
    // ・選択チェック状態の行が複数ある場合、メッセージを表示し処理を終了する。
    const isMultiChecked = this.kymw1700Model.imageInfoList.filter(_ => _.checked).length > 1;
    if (isMultiChecked) {
      this.dialogService.openAlertGetMessage('E0550', ['作成指示済み画像ファイル']);
      return;
    }
    const isC2pfStatus2 = this.kymw1700Model.imageInfoList.filter(_ => _.checked && _.c2pfStatus === '2').length === 0;
    if (isC2pfStatus2) {
      this.dialogService.openAlertGetMessage('E0552', null);
      return;
    }
    // 選択した行のサンプル発注先名称、取引先への連絡事項、画像ファイル名
    const selectedOne = this.kymw1700Model.imageInfoList.filter(_ => _.checked)[0];
    const componentRef = this.dialogService.openModal(KYMW1707Component);
    const instance = componentRef.componentInstance as KYMW1707Component;
    instance.setParameter(selectedOne.sampleOrderingName, selectedOne.supplierAnnouncement, selectedOne.imageFileName);
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  /**
   * 過去画像登録ボタンを押下
   */
  public eventClickHandler_RegisterPastImage() {
    // ・選択チェック状態の行が１行もない場合、下記のメッセージを表示し処理を終了する。
    const isNotChecked = this.kymw1700Model.imageInfoList.filter(_ => _.checked).length === 0;
    if (isNotChecked) {
      this.dialogService.openAlertGetMessage('E0103', ['作成指示済み画像ファイル']);
      return;
    }
    // ・選択チェック状態の行が複数ある場合、メッセージを表示し処理を終了する。
    const isMultiChecked = this.kymw1700Model.imageInfoList.filter(_ => _.checked).length > 1;
    if (isMultiChecked) {
      this.dialogService.openAlertGetMessage('E0550', ['作成指示済み画像ファイル']);
      return;
    }
    // 選択した行の画像ID
    const selectedOne = this.kymw1700Model.imageInfoList.filter(_ => _.checked)[0];

    // ・選択した行の画像使用方法が「過去画像」かつ、C2PFステータスが「8：過去画像入稿待ち」以外の場合
    // E0554: 過去画像登録は画像使用方法が過去画像かつ、C2PFステータスが8：過去画像入稿待ちの行のみ選択してください。
    const isC2pfStatus8 = selectedOne.imageUseMethodName === '過去画像使用' && selectedOne.c2pfStatus === '8';
    if (!isC2pfStatus8) {
      this.dialogService.openAlertGetMessage('E0554');
      return;
    }
    const componentRef = this.dialogService.openModal(KYMW1705Component);
    const instance = componentRef.componentInstance as KYMW1705Component;
    instance.setParameter(selectedOne.imageId);
    instance.closeFunction = () => {
      componentRef.close();
      // 3.	処理が成功した場合、画像ファイル一覧の再検索を行う。	
      this.getImageInfoList();
    };
  }

  /**
   * 承認ボタンを押下
   */
  public eventClickHandler_Approval() {
    // ・選択チェック状態の行が１行もない場合、下記のメッセージを表示し処理を終了する。
    const isNotChecked = this.kymw1700Model.imageInfoList.filter(_ => _.checked).length === 0;
    if (isNotChecked) {
      this.dialogService.openAlertGetMessage('E0103', ['作成指示済み画像ファイル']);
      return;
    }
    // ・選択した行のC2PFステータスが「9：画像承認待ち」以外の場合、メッセージを表示し処理を終了する。
    const isC2pfStatus9 = this.kymw1700Model.imageInfoList.filter(_ => _.checked && _.c2pfStatus !== '9').length > 0;
    if (isC2pfStatus9) {
      this.dialogService.openAlertGetMessage('E0555');
      return;
    }
    // 画像承認完了ステータスに変更する
    const imageFileNames = this.kymw1700Model.imageInfoList
      .filter(_ => _.checked && _.c2pfStatus === '9').map(_ => _.imageFileName);
    this.updateC2pfStatusService.execute(imageFileNames, null, '10', () => {
      // 再検索して終了
      this.getImageInfoList();
      this.dialogService.openAlertGetMessage('I0106', ['承認が完了']);
    });
  }

  /**
   * 差し戻しボタンを押下
   * @returns 
   */
  public eventClickHandler_Remand() {
    // ・選択チェック状態の行が１行もない場合、下記のメッセージを表示し処理を終了する。
    const isNotChecked = this.kymw1700Model.imageInfoList.filter(_ => _.checked).length === 0;
    if (isNotChecked) {
      this.dialogService.openAlertGetMessage('E0103', ['作成指示済み画像ファイル']);
      return;
    }
    // ・選択チェック状態の行が複数ある場合、メッセージを表示し処理を終了する。
    const isMultiChecked = this.kymw1700Model.imageInfoList.filter(_ => _.checked).length > 1;
    if (isMultiChecked) {
      this.dialogService.openAlertGetMessage('E0550', ['作成指示済み画像ファイル']);
      return;
    }
    // ・選択した行のC2PFステータスが「3：サンプル手配済み」～「10：画像承認完了」以外の場合、メッセージを表示し処理を終了する。
    const isC2pfStatus = this.kymw1700Model.imageInfoList.filter(_ => _.checked && ['3', '4', '5', '6', '7', '8', '9', '10'].includes(_.c2pfStatus)).length === 0;
    if (isC2pfStatus) {
      this.dialogService.openAlertGetMessage('E0556');
      return;
    }
    // 選択した行の商品案内用商品名、商品案内用規格名、画像ファイル名
    const selectedOne: ImageInfoModel = this.kymw1700Model.imageInfoList.filter(_ => _.checked)[0];
    const componentRef = this.dialogService.openModal(KYMW1706Component);
    const instance = componentRef.componentInstance as KYMW1706Component;
    instance.setParameter(selectedOne.guideGoodsName, selectedOne.guideStandardName, selectedOne.imageFileName);
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  /**
   * コンテキストメニューを追加
   */
  private setContextMenu(): void {
    this.contextMenu = new Menu(document.createElement('div'),
      {
        displayMemberPath: 'caption',
        selectedValuePath: 'cmd',
        itemsSource: [
          { caption: '画像作成指示編集', cmd: 'imageMakeInstruction', enabled: false },
          { caption: '画像作成指示削除', cmd: 'imageMakeInstructionDelete', enabled: false },
          { caption: 'アップロード画像確認', cmd: 'uploadImageCheck', enabled: false },
        ],
        command: this.getFormatMenuCommand(),
        itemClicked: () => {
          switch (this.contextMenu.selectedValue) {
            case 'imageMakeInstruction':
              this.eventImageMakeInstructionEdit_CLICKHandler();
              break;
            case 'imageMakeInstructionDelete':
              this.eventImageMakeInstructionDelete_CLICKHandler();
              break;
            case 'uploadImageCheck':
              this.eventUploadImageCheck_CLICKHandler();
              break;
          }
        }
      });
    this.dtg_ImageInfo.hostElement.addEventListener('contextmenu', (e: any) => {
      // イベントを停止後、メニュー表示
      e.preventDefault();
      if (this.contextMenu !== undefined) {

        const ht = this.dtg_ImageInfo.hitTest(e.pageX, e.pageY);
        if (ht.cellType === CellType.Cell) {
          // 選択した行がすでに選択されていない行の場合はその行を選択（既に選択されている行はクリア）
          const alreadySelectedRow = this.dtg_ImageInfo.selectedRows.filter(row => row.index === ht.row);
          if (PlessViewUtilsSub.isEmptyArray(alreadySelectedRow)) {
            // 右クリック押下時に対象行を選択状態にする
            const grid = new CellRange(ht.row, ht.col);
            this.dtg_ImageInfo.select(grid, false);
            this.setColorPattern(this.dtg_ImageInfo);
          }
          // コンテキストメニューの活性非活性制御
          this.eventContextMenu_Handler();
          // メニュー表示
          this.contextMenu.show(e);
        } else {
          // コンテキストメニューの活性非活性制御
          this.eventContextMenu_Handler(false);
          // メニュー表示
          this.contextMenu.show(e);
        }
      }
    });
  }

  private getFormatMenuCommand(): any {
    return {
      canExecuteCommand: (param) => {
        // 各項目の活性制御
        return (param.enabled === false) ? false : true;
      }
    };
  }

  /**
   * 右クリックメニューが表示されたときに呼び出されるメソッド
   * メニュー項目の表示設定を行う
   *
   * @param event:コンテキストイベント
   */
  private eventContextMenu_Handler(isEnabled = true): void {
    const selectedItemCnt: number = this.dtg_ImageInfo.selectedItems.length;

    this.contextMenu.itemsSource.forEach((item: { enabled: boolean; caption: string; }) => {
      if (isEnabled) {
        item.enabled = true;
        // 閲覧ユーザの場合、「画像作成指示編集」以外のコンテキストメニューを無効化
        if (this.kymw00Model.kymw1001Model.topFuncReadOnlyMode && item.caption !== '画像作成指示編集') {
          item.enabled = false;
          // 複数行選択時は「画像作成指示編集」「アップロード画像確認」を無効化
        } else if (['画像作成指示編集', 'アップロード画像確認'].includes(item.caption) && selectedItemCnt > 1) {
          item.enabled = false;
        }
        // 出力帳票選択：一覧編集モードの場合は無効化
        if (['画像作成指示編集', '画像作成指示削除'].includes(item.caption) && this.kymw1700Model.mode === 1) {
          item.enabled = false;
        }
        // 選択した行の画像種類が「メーカーデータ」かつ「C2PF対象」の場合、全て活性
        // 上記以外の場合、アップロード画像確認は非活性
        if (!(this.dtg_ImageInfo.selectedItems[0].imageKind === '3' && this.dtg_ImageInfo.selectedItems[0].c2pfTarget === '1')
          && item.caption === 'アップロード画像確認') {
          item.enabled = false;
        }

      } else {
        // メニュー項目の非表示設定
        item.enabled = false;
      }
    });
  }

  /**
    * 画像情報リストを取得する
    *
    * @private
    * @memberof KYMW1700Component
    */
  private getImageInfoList(): void {
    // C2PFステータスのコード名を表示する。（ctp257）
    this.getCodeListService.execute(
      "ctp257",
      "",
      this.kymw1700Model,
      "c2pfStatusNames",
      () => {
        const c2pfStatusNames = [];
        for (const e of this.kymw1700Model.c2pfStatusNames) {
          c2pfStatusNames[e.CodeValue] = e.CodeName;
        }
        // 検索条件を設定
        const requestVo: GetImageInfoRequestModel = this.kymw1700Model.getGetImageInfoVO(this.kymw1700Model.kymw0B00Param);
        // 検索実行
        this.getImageInfoService.execute(requestVo, (data: GetImageInfoResponseModel[]) => {
          this.kymw1700Model.updateImageInfoList(this.dialogService, data, c2pfStatusNames);
        },
          () => {
            this.kymw1700Model.clearDisplay();
          }
        );
      }
    );
  }

  /**
   * 画像検索画面からの結果を取得処理
   *
   * @param {KYMW0B00OutputModel} outputVO
   * @memberof KYMW1700Component
   */
  public setKYMW0B00Parameter(outputVO: KYMW0B00OutputModel): void {
    this.kymw1700Model.requestVO = this.kymw1700Model.getGetImageInfoVO(outputVO);
  }

  /**
   * 「画像作成指示」ボタン押下イベント処理
   *
   * @memberof KYMW1700Component
   */
  public eventImageMakeInstruction_CLICKHandler(): void {
    // 画像作成指示画面を呼び出す（新規モード）
    const componentRef = this.dialogService.openModal(KYMW0C00Component);
    const instance = componentRef.componentInstance as KYMW0C00Component;
    instance.parent = this;
    const kymw0C00InputVO: KYMW0C00InputModel = new KYMW0C00InputModel();
    kymw0C00InputVO.ProcessDiv = 1;
    instance.setInterfaceParam(kymw0C00InputVO);
    instance.closeFunction = () => {
      this.eventSubWindowClose();
      componentRef.close();
    };
  }

  /**
   * コンテキスト「画像作成指示編集」選択イベント処理
   *
   * @private
   * @memberof KYMW1700Component
   */
  private eventImageMakeInstructionEdit_CLICKHandler(): void {

    // 実績履歴画面(モーダレス)を表示する。
    this.kymw0C00ComponentRef =
      this.dialogService.openModelessSub(
        this, KYMW0C00Component,
        this.viewContainerRef, this.kymw0C00ComponentRef, null, 0, '', true);

    if (this.kymw0C00ComponentRef != null) {
      const kymw0C00InputVO: KYMW0C00InputModel = new KYMW0C00InputModel();
      kymw0C00InputVO.ProcessDiv = 2;
      kymw0C00InputVO.ImageID = this.dtg_ImageInfo.selectedItems[0].imageId;
      this.kymw0C00Component = this.kymw0C00ComponentRef.instance as KYMW0C00Component;
      this.kymw0C00Component.parent = this;
      this.kymw0C00Component.setInterfaceParam(kymw0C00InputVO);

      // ウィンドウが閉じられる際の処理
      this.kymw0C00Component.closeFunction = () => {
        this.eventSubWindowClose();
        this.kymw0C00ComponentRef.destroy();
      };
    }
  }

  /**
   * コンテキスト「画像作成指示削除」選択イベント処理
   * @private
   * @memberof KYMW1700Component
   */
  private eventImageMakeInstructionDelete_CLICKHandler(): void {
    // 注）	ステータスが撮影指示待ち、ファイル									
    // 待ち状態の作成指示情報しか削除できない。									
    // 複数選択時、『画像登録済』が含まれて									
    // いる場合は、エラーとする。									


    // 削除確認
    this.dialogService.openAlertGetMessage('Q0106', ['画像作成指示'], (closeDetail) => {
      // 確認結果が「はい」の場合は、画面の遷移処理を実施する。
      if (closeDetail === PlessAlert.Yes) {
        this.ImageMakeInstructionDelete();
      }
    });
  }

  /**
   * 画像作成指示削除処理
   *
   * @private
   * @memberof KYMW1700Component
   */
  private ImageMakeInstructionDelete(): void {
    // 選択された画像に、「画像登録済み」が含まれているかチェック
    const arySelectedItems: Array<any> = this.dtg_ImageInfo.selectedItems;

    // 「画像登録済み」が含まれている場合、エラー
    const errorImageInfo = arySelectedItems.filter(item => item.status === '2');
    if (!PlessViewUtilsSub.isEmptyArray(errorImageInfo)) {
      this.dialogService.openAlertGetMessage('E0180');
      return;
    }

    // サービス実行用に配列に画像IDを詰めなおし
    const images = [];
    arySelectedItems.forEach(element => images.push(element.imageId));

    const deleteVo = { formId: 'KYMW1700', imageId: images };
    this.deleteImageInfoService.execute(deleteVo, (serverData: any) => {
      // 画面の再表示処理
      this.deleteImageInfoList(arySelectedItems, serverData);
    });
  }

  /**
   * 画像削除後の再表示処理
   *
   * @param {*} selectedList
   * @param {*} serverData サーバから受信したデータ
   * @returns {void}
   * @memberof KYMW1700Component
   */
  private deleteImageInfoList(selectedList: any, serverData: any): void {
    // サーバーからの返却値にコードが含まれている場合
    if (!PlessViewUtilsSub.isEmpty(PlessViewUtilsSub.nullToBlank(serverData.Code)) &&
      PlessViewUtilsSub.nullToBlank(serverData.Code) === 'E0200') {

      const imageId: string = serverData.ImageID;

      // 選択された画像IDの一覧のうち、指定された画像IDの情報を返却する
      const errorImageInfo = selectedList.find(item => item.imageId === imageId);

      // メッセージコードが「E0200(使用ページ確認、削除エラー)」の場合
      const inputVo: KYMW0E00InputModel = new KYMW0E00InputModel();
      inputVo.processDiv = 3;
      inputVo.imageID = imageId;                                                // 画像ID(メッセージ部に格納)
      inputVo.imageFileName = errorImageInfo.imageFileName;                     // 画像ファイル名(画像IDからデータ取得)
      inputVo.imageName = errorImageInfo.imageName;                             // 画像名(画像IDからデータ取得)

      // 使用ページ確認(削除)を呼び出す
      const componentRef = this.dialogService.openModal(KYMW0E00Component);
      const instance = componentRef.componentInstance as KYMW0E00Component;
      instance.parent = this;
      instance.setInterfaceParam(inputVo);
      instance.setKYMW0E00Parameter = (outputVO: KYMW0E00OutputModel) => {
        // 処理は何もしない
      };
      instance.closeFunction = () => {
        componentRef.close();
      };
      return;
    }

    // 画面再検索
    this.getImageInfoList();
  }

  /**
   * コンテキスト「アップロード画像確認」選択イベント処理
   */
  private eventUploadImageCheck_CLICKHandler() {
    // 選択した画像IDでアップロード画像確認を開く
    const selectedItem = this.dtg_ImageInfo.selectedItems[0];
    const componentRef = this.dialogService.openModal(KYMW1709Component);
    const instance = componentRef.componentInstance as KYMW1709Component;
    instance.setParameter(selectedItem.imageFileName);
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  /**
   * サブ画面終了時の再描画処理
   *
   * @memberof KYMW1700Component
   */
  public eventSubWindowClose(): void {
    if (this.kymw1700Model.existsSearchCondition) {
      this.getImageInfoList();
    }
  }

  /**
   * 閲覧権限ユーザであるかどうか
   */
  public isPermissionReadonly(): boolean {
    return this.getFuncPermission() === this.kymw00Model.FUNC_PERMISSION_READONLY;
  }

  /**
   * データグリッド行の背景色設定
   *
   * @param grid 処理対象データグリッド
   */
  public setColorPattern(grid: FlexGrid): void {
    // 背景色設定
    grid.rows.forEach((row) => {
      // 状態のチェック(0：通常、1：使用停止されている)
      if (row.dataItem.enabled === '1') {
        if (row.isSelected) {
          row.cssClass = 'deactivated-image-selected';
        } else {
          row.cssClass = 'deactivated-image';                                 // 使用不可：赤
        }
      } else {
        row.cssClass = 'image-enabled-true';                                    // 使用可　：白
      }
    });
  }

  /**
   * 撮影予定日、変更前撮影予定日の値を変更したときの処理
   * @param index 
   * @param tag 
   */
  public eventChangeHandler_ScheduleDate(index: number, tag: any) {
    // 日付選択のドロップダウンが開いていて、かつ日付が変更されたときに動く
    if (tag.isDroppedDown) {
      this.eventChangeHandler_DtgImageInfoCell(index);
    }
  }
}
